module.exports = __webpack_public_path__ + "media/images/logo/logo-blue-07744cb24915e3eabfdafd260af5404e.png";